import React from "react";
import waImg from "Assets/whatsapp.png";

const FloatingWhatsApp: React.FC = () => {
  const waUrl =
    "https://wa.me/917300015860?text=Hi%2C+I+found+Math+Ninja+on+your+website";

  return (
    <>
      <style>{`
        .floating-wa { position: fixed; right: 20px; bottom: 40px; z-index: 9999; display: flex; align-items: center; justify-content: center; text-decoration: none; }

        /* Smaller main bubble */
        .wa-bubble {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          cursor: pointer;
          transform-origin: center;
          transition: transform .14s ease, box-shadow .14s ease;
          background: radial-gradient(circle at 28% 24%, #0c6b2f 0%, #128C4E 40%, #0a5a28 100%);
          box-shadow: 0 8px 20px rgba(12,107,47,0.22), 0 2px 6px rgba(0,0,0,0.22);
          animation: float 3.6s ease-in-out infinite;
          z-index: 6;
        }

        .floating-wa:hover .wa-bubble { transform: scale(1.06); box-shadow: 0 14px 28px rgba(12,107,47,0.32), 0 4px 10px rgba(0,0,0,0.26); }

        .wa-bubble img { width: 34px; height: 34px; object-fit: contain; position: relative; z-index: 4; }

        /* gentle float */
        @keyframes float { 0% { transform: translateY(0px); } 50% { transform: translateY(-6px); } 100% { transform: translateY(0px); } }

        /* Large water-like waves (outer rings) */
        .wa-waves { position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%); pointer-events: none; z-index: 1; }
        .wa-waves .wave { position: absolute; border-radius: 50%; border: 3px solid rgba(8,86,39,0.28); width: 140px; height: 140px; left: 50%; top: 50%; transform: translate(-50%,-50%) scale(0.6); opacity: 0; box-shadow: 0 0 30px rgba(8,86,39,0.18); }
        .wa-waves .wave.w1 { animation: wave 3.2s cubic-bezier(.25,.8,.25,1) infinite; }
        .wa-waves .wave.w2 { width: 110px; height: 110px; animation: wave 3.2s cubic-bezier(.25,.8,.25,1) infinite; animation-delay: 0.8s; }
        .wa-waves .wave.w3 { width: 170px; height: 170px; animation: wave 3.2s cubic-bezier(.25,.8,.25,1) infinite; animation-delay: 1.6s; }

        @keyframes wave {
          0% { transform: translate(-50%,-50%) scale(0.6); opacity: 0.95; }
          65% { transform: translate(-50%,-50%) scale(1.6); opacity: 0.18; }
          100% { transform: translate(-50%,-50%) scale(2.1); opacity: 0; }
        }

        /* inner soft ripples (more visible) */
        .wa-ripples { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; pointer-events: none; z-index: 2; }
        .wa-ripples .r { position: absolute; border-radius: 50%; width: 84px; height: 84px; background: rgba(8,86,39,0.22); box-shadow: 0 0 36px rgba(8,86,39,0.22); opacity: 0; }
        .wa-ripples .r.r1 { animation: ripple 2.2s ease-out infinite; }
        .wa-ripples .r.r2 { animation: ripple 2.2s ease-out infinite; animation-delay: 0.7s; }

        @keyframes ripple { 0% { transform: scale(0.75); opacity: 0.95; } 60% { transform: scale(1.6); opacity: 0.22; } 100% { opacity: 0; } }

        /* small blinking dots around bubble */
        .blink { position: absolute; pointer-events: none; z-index: 5; }
        .blink span { position: absolute; width: 8px; height: 8px; border-radius: 50%; background: #0f7a3a; box-shadow: 0 0 10px rgba(12,107,47,0.95); opacity: 0.0; }
        .blink .b1 { left: -6px; top: 10px; animation: blink 1.2s infinite; animation-delay: 0.05s; }
        .blink .b2 { right: -6px; top: 16px; animation: blink 1.2s infinite; animation-delay: 0.35s; }
        .blink .b3 { left: 50%; top: -8px; transform: translateX(-50%); animation: blink 1.2s infinite; animation-delay: 0.7s; }

        @keyframes blink { 0% { opacity: 0.0; transform: scale(0.85); } 45% { opacity: 1; transform: scale(1.15); } 100% { opacity: 0.0; transform: scale(0.85); } }

        /* grow-and-fade circles (user-provided style adapted) */
        .circles { width: 200px; height: 200px; position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%); pointer-events: none; z-index: 1; }
        .circles > div { animation: growAndFade 3s infinite ease-out; background-color: rgba(12,107,47,0.14); border-radius: 50%; height: 100%; opacity: 0; position: absolute; width: 100%; left: 0; top: 0; }
        .circles .circle1 { animation-delay: 0s; }
        .circles .circle2 { animation-delay: 1s; }
        .circles .circle3 { animation-delay: 2s; }

        @keyframes growAndFade {
          0% { opacity: 0.35; transform: scale(0); }
          100% { opacity: 0; transform: scale(1); }
        }
      `}</style>

      <a
        href={waUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-wa"
        aria-label="Contact us on WhatsApp"
      >
        <div className="wa-bubble" role="img" aria-hidden>
          <div className="wa-ripples">
            <span className="r r1" />
            <span className="r r2" />
            <span className="r r3" />
          </div>
          <img src={waImg} alt="WhatsApp" />
        </div>

        {/* grow-and-fade circles around the bubble */}
        <div className="circles" aria-hidden>
          <div className="circle1" />
          <div className="circle2" />
          <div className="circle3" />
        </div>
      </a>
    </>
  );
};

export default FloatingWhatsApp;
